module.exports = __webpack_public_path__ + "img/04-min.2e8a1f15.png";